import { render } from "./index.vue?vue&type=template&id=e12401f2"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"

import "./index.vue?vue&type=style&index=0&id=e12401f2&lang=less"
script.render = render

export default script